import { Suspense, type ComponentType, type LazyExoticComponent } from 'react'

interface LazyImportProps {
  LazyChildren: LazyExoticComponent<ComponentType>
}

export default function LazyImport({ LazyChildren }: LazyImportProps) {
  return (
    <Suspense fallback={null}>
      <LazyChildren />
    </Suspense>
  )
}
